<section class="section-wrapper">
    <h2 class="cam-heading">Manage travelers</h2>

    <div class="section-context">
        <div class="menu-left-content">
            <app-menu-nav-expanded></app-menu-nav-expanded>
        </div>
        <div class="right-content">
        </div>
    </div>
</section>